/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';

import v from './validators';
import fetch from '../../core/fetch/fetch.server';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const ownershipOptions = [
  {
    label: 'właśność',
    value: 'własnością',
    state: 'ownershipType',
  },
  {
    label: 'użytkowanie wieczyste',
    value: 'w użytkowaniu wieczystym',
    state: 'ownershipType',
  },
  {
    label: 'władanie',
    value: 'we władaniu',
    state: 'ownershipType',
  },
];

const InfoTypeDict = {
  town: {
    label: 'Miejscowość:',
    editable: true,
  },
  decisionNumber: {
    label: 'Nr księgi wieczystej:',
    editable: true,
  },
  owner: {
    label: 'Imię i nazwisko/nazwa właściciela nieruchomości:',
    editable: true,
    type: 'textarea',
  },
  ownershipType: {
    label: 'Rodzaj władania nieruchomością:',
    editable: true,
    type: 'Select',
    options: ownershipOptions,
  },
};


class RozgraniczenieNieruchomosci extends React.Component {
  state = {
    info: {
      town: null,
      decisionNumber: null,
      ownershipType: null,
      otherownershipType: null,
      owner: null,
    },
    listParcels: [{
      obreb: '',
      parcelNumber: '',
      parcelDecNumber: '',
      parcelOwner: '',
    }],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
  };

  validators = {
    town: [v.NotNull],
    decisionNumber: [v.NotNull],
    ownershipType: [v.NotSelected],
    owner: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentWillMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    if (name === 'ownershipType' && e.value !== 'we władaniu') {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
            otherownershipType: null,
          },
        },
        () => this.validate(group, name),
      );
    }
    else {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
          },
        },
        () => this.validate(group, name),
      );
    }
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        town: 'Warszawa',
        decisionNumber: 'AAA1234',
        ownershipType: 'własnością',
        otherownershipType: '',
        owner: 'Właściciel testowy',
      },
      listParcels: [{
        obreb: '2.001',
        parcelNumber: '123',
        parcelDecNumber: '234/1',
        parcelOwner: 'Jan Kowalski',
      }, {
        obreb: '2.002',
        parcelNumber: '224',
        parcelDecNumber: '222/54',
        parcelOwner: 'Andrzej Nowak',
      }],
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }
    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          listParcels: this.state.listParcels,
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  addParcel = () => {
    this.setState({
      listParcels: [...this.state.listParcels, {
        obreb: '',
        parcelNumber: '',
        parcelDecNumber: '',
        parcelOwner: '',
      }],
    });
  }

  removeParcel = (i, state) => {
    const list = [...this.state[state]];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      [state]: list,
    });
  }

  onChangeParcel = (e, state, elem, index) => {
    const arr = this.state[state];
    arr[index][elem] = e.target.value;

    this.setState({
      [state]: arr,
    },
    () => this.validate(state, elem),
    );
  }

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <GrayPanel
          title={'1. Adres'}
        >
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden
            z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li>
                {' '}
                Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer
                działki. W celu dodania kolejnej działki należy powtórzyć czynność.
              </li>
              <li>
                Wskazać działkę w oknie mapy wykorzystując przycisk{' '}
                <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest
                przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.
              </li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku{' '}
            <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        <DecisionContainer
          title={'2. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        >
          {this.state.info.ownershipType === 'we władaniu' ?
            <p style={{ textAlign: 'justify' }}>
              <div className={'col-sm-1'} />
              <div className={'col-sm-3'}>
                <label style={{ marginTop: '.5rem' }}>Wprowadź rodzaj władania:</label>
              </div>
              <div className={'col-sm-7'}>
                <input
                  className="form-control"
                  name={'otherownershipType'}
                  style={{
                    marginTop: '.5rem',
                    width: '100%',
                    borderColor:
                      Object.keys(this.state.errors).indexOf('otherownershipType') > -1 &&
                        this.state.errors.otherownershipType !== null &&
                        this.state.errors.otherownershipType.length > 0
                        ? 'red'
                        : '#ccc',
                  }}
                  value={this.state.info.otherownershipType ? this.state.info.otherownershipType : ''}
                  onChange={e => this.onChange(e, 'info')}
                />
              </div>
            </p> :
          null
        }
        </DecisionContainer>
        <GrayPanel
          title={'3. Nieruchomości sąsiednie'}
        >
          <div className="row">
            <div className="col-sm-8">
              Lista nieruchomości sąsiednich:
            </div>
            <div className="col-sm-4">
              <button
                type="submit-lg"
                className={'btn btn-primary'}
                style={{ float: 'right', ...btnStyle }}
                onClick={() => this.addParcel()}
              >
                Dodaj nieruchomość
            </button>
            </div>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Lp.</th>
                <th scope="col">Obręb ewidencyjny</th>
                <th scope="col">Numer działki</th>
                <th scope="col">Numer księgi wieczystej</th>
                <th scope="col">Właściciel</th>
              </tr>
            </thead>
            <tbody>
              {this.state.listParcels.map((v, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={v.name}
                        placeholder="Obręb..."
                        onChange={(e) => this.onChangeParcel(e, 'listParcels', 'obreb', i)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={v.birthDate}
                        placeholder="Numer działki..."
                        onChange={(e) => this.onChangeParcel(e, 'listParcels', 'parcelNumber', i)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={v.relationshipLevel}
                        placeholder="Numer księgi wieczystej..."
                        onChange={(e) => this.onChangeParcel(e, 'listParcels', 'parcelDecNumber', i)} />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={v.income}
                        placeholder="Właściciel..."
                        onChange={(e) => this.onChangeParcel(e, 'listParcels', 'parcelOwner', i)}
                      />
                    </td>
                    <td>
                      <button
                        type="submit-lg"
                        className={'btn btn-danger'}
                        style={{ btnStyle }}
                        onClick={() => this.removeParcel(i, 'listParcels')}
                      >
                        Usuń
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </GrayPanel>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

RozgraniczenieNieruchomosci.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(RozgraniczenieNieruchomosci),
);



// WEBPACK FOOTER //
// src/routes/eservices/RozgraniczenieNieruchomosci.js